<template>
  <module-page v-bind="pageParams" :customBreadcrumbs="customBreadcrumbs">
    <v-layout row wrap>
      <v-flex xs12 md8 lg8 class="mb-2">
        <v-layout
          row
          v-if="hasDocs"
          :wrap="mobile"
          align-center
          justify-space-between
          class="pl-0 pr-0 mb-2"
        >
          <v-tabs class="page__tabs opaque" hide-slider v-model="selectedTab">
            <v-tab
              v-for="(tab, i) in tabs"
              :to="tab.value"
              :key="i"
              active-class="docs--background white--text"
              >{{ tab.title }}</v-tab
            >
          </v-tabs>
        </v-layout>
        <screen-loading v-if="docsLoading && !hasDocs"></screen-loading>
        <div v-else>
          <owner-doc-list
            class="pl-1"
            :params="enums.ownerDocuments"
            :themeColor="pageParams.themeColor"
            :emptyState="pageParams.emptyState"
            :items="ownerDocs"
            @previewFile="
              (v) => {
                previewFile(v, 'owner');
              }
            "
            :statusParams="enums.ownerDocumentsStatus"
            :visualizedFilter="ownerVisualizedFilter"
            :error="docsError"
          >
            <template slot="previewButton" slot-scope="{ item }">
              <form
                v-if="item.type === 'syndicDocument'"
                method="POST"
                :action="item.attachment"
                target="_blank"
              >
                <input
                  type="hidden"
                  name="idemp"
                  :value="selectedUnit.product.code"
                />
                <input type="hidden" name="sindico" :value="syndicUnit" />
                <v-btn
                  type="submit"
                  v-if="item.attachment"
                  :style="{ color: pageParams.themeColor }"
                  @click="$emit('previewFile', item)"
                >
                  <i class="bexsicon-docs-sm" />
                  Exibir documento
                </v-btn>
              </form>
            </template>
          </owner-doc-list>
          <div v-if="docsError" class="empty-state">
            {{ enums.responses.error }}
          </div>
        </div>
      </v-flex>
      <v-flex xs12 md4 lg4 :class="`mb-4 ${!mobile ? 'mt-2' : 'mt-4'}`">
        <faq-card
          :items="faqItems"
          :loading="faqLoading"
          :error="faqError"
          :params="faqCardParams"
          :errorText="enums.responses.error"
          @faqSelected="goToFaq"
          :retryFunction="getFaqs"
        ></faq-card>
      </v-flex>
    </v-layout>
  </module-page>
</template>

<script>
import ModulePage from '@/components/layout/Page';
import FaqCard from '@/components/modules/FaqCard';
import SelectField from '@/components/fields/Select';
import ScreenLoading from '@/components/loaders/ScreenLoading';
import OwnerDocList from '@/components/document/OwnerDocList';
import faqMixin from '@/mixins/modules/faq';
import { APP, DOCS, NOTIFICATIONS } from '@/utils/constants';

export default {
  name: 'documents',
  mixins: [faqMixin],
  components: {
    ModulePage,
    FaqCard,
    SelectField,
    ScreenLoading,
    OwnerDocList,
  },
  computed: {
    customBreadcrumbs() {
      return [{ text: 'Documentos' }, { text: this.pageParams.title }];
    },
    ownerDocs() {
      return this.$store.getters[DOCS.GET_SYNDIC_DOCS];
    },
    tabs() {
      return this.pageParams.tabs;
    },
    syndicUnit() {
      let unitSplit = this.selectedUnit.sku.split('-');
      let value =
        unitSplit.length == 3
          ? unitSplit[unitSplit.length - 2]
          : unitSplit[unitSplit.length - 1];
      return value.toLowerCase();
    },
  },
  data() {
    return {
      pageParams: this.$store.getters[APP.PAGES].syndicDocs,
      faqCardParams: this.$store.getters[APP.APP_MODULES].faq,
      selectedTab: '',
      ownerString: 'proprietario',
      faqs: [],
      faqsLoading: false,
      faqsError: false,
      ownerVisualizedFilter: null,
      hasDocs: false,
      ownerDocuments: [],
      docsLoading: false,
      docsError: false,
    };
  },

  created() {
    this.selectedTab = this.$route.params.type;
    this.getFaqs();
  },
  methods: {
    previewFile({ title, attachment, _id }, type) {
      window.open(attachment, '_blank');
      const action = this.enums.logTraceActions[`${type}DocsDownload`];
      this.createTrace(action, { title, attachment });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';

.document {
  &__visualized-filter {
    padding: 0px;

    >>> .v-input__slot {
      width: 200px;
      @include breakpoint(not-mobile) {
        margin-left: auto;
        margin-right: 22px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/document/SyndicDocuments.vue